import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY } from './common';

const routes = [
    {
        matchRegex: '/JobTemplate/Detail',
        name: 'Job Template - Detail',
        slots: [
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'job-cost-material', label: 'Job Cost - Material Line' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { 
                    key: 'MARKETPLACE_EVENT_AFTER_SAVE_COST_LINE_SUCCESS', 
                    label: 'After save cost line success' 
                },
                { 
                    key: 'MARKETPLACE_EVENT_AFTER_DELETE_COST_LINE_SUCCESS', 
                    label: 'After delete cost line success' 
                },
            ],
        },
        replaceElements: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity-cost-elements', label: 'Material Cost Quantity Elements' },
            ],
        },
    },
]

export default routes;